import { defineMessages } from 'react-intl';
import * as DT from '../../constants/constant_custom_field_types';

export default defineMessages({
  [DT.BOOLEAN]: {
    defaultMessage: 'Boolean',
    id: 'custom_field.boolean.title',
  },
  [DT.CURRENCY]: {
    defaultMessage: 'Currency',
    id: 'custom_field.currency.title',
  },
  [DT.DATE]: {
    defaultMessage: 'Date',
    id: 'custom_field.date.title',
  },
  [DT.DATETIME]: {
    defaultMessage: 'Datetime',
    id: 'custom_field.datetime.title',
  },
  [DT.DECIMAL]: {
    defaultMessage: 'Decimal',
    id: 'custom_field.decimal.title',
  },
  [DT.INTEGER]: {
    defaultMessage: 'Integer',
    id: 'custom_field.integer.title',
  },
  [DT.LINK]: {
    defaultMessage: 'Link',
    id: 'custom_field.link.title',
  },
  [DT.LIST]: {
    defaultMessage: 'List',
    id: 'custom_field.list.title',
  },
  [DT.RECORD]: {
    defaultMessage: 'Record',
    id: 'custom_field.record.title',
  },
  [DT.STRING]: {
    defaultMessage: 'String',
    id: 'custom_field.string.title',
  }
});
